import { useCallback } from "react";
export function useChatEventGAPush() {
  const guideLineAgreementEvent = useCallback(roomId => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "comp_guideline",
      roomid: roomId
    });
  }, []);
  const joinRoomEvent = useCallback(roomId => {
    window.dataLayer.push({
      event: "join_room",
      roomid: roomId
    });
  }, []);
  const sendCommentEvent = useCallback((roomId, hashedUserId) => {
    window.dataLayer.push({
      event: "comp_comment",
      roomid: roomId
    });
    window.dataLayer.push({
      event: "comp_comment",
      userid: hashedUserId
    });
  }, []);
  const reportCommentEvent = useCallback(() => {
    window.dataLayer.push({
      event: "comp_report_comment"
    });
  }, []);
  return {
    guideLineAgreementEvent,
    joinRoomEvent,
    sendCommentEvent,
    reportCommentEvent
  };
}